import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Marketplace } from './pages/Marketplace';
import { Checkout } from './pages/Checkout';
import { Admin } from './pages/Admin';
import { VisionPage } from './pages/VisionPage';
import { PartnerPage } from './pages/PartnerPage';
import { CartProvider } from './CartContext';
import { ContentProvider } from './ContentContext';
export function App() {
  return <ContentProvider data-id="element-0" data-mp="2mjzo18kbdvo5">
    <CartProvider data-id="element-1" data-mp="31agp2qt1ejki">
      <BrowserRouter data-id="element-2" data-mp="31ayq00qn9lyr">
        <div className="flex min-h-screen w-full flex-col bg-warm text-brun" data-id="element-3" data-mp="31c9uy3vtszrg">
        <Navbar data-id="element-4" data-mp="2wjqkvgwckmre" />
        <main className="flex-1" data-id="element-5" data-mp="2wj8g1vvmd07v">
          <Routes data-id="element-6" data-mp="2wi5lndz38fn7">
            <Route path="/" element={<Home data-id="element-8" data-mp="28te198rqp1kz" />} data-id="element-7" data-mp="28u5zysgmvffh" />
            <Route path="/utbud" element={<Marketplace data-id="element-10" data-mp="28s2ztflro5x1" />} data-id="element-9" data-mp="28suvsrja05nu" />
            <Route path="/partner/:slug" element={<PartnerPage data-id="element-12" data-mp="23utb6267bya9" />} data-id="element-11" data-mp="23vupcfiil0w7" />
            <Route path="/vision" element={<VisionPage data-id="element-14" data-mp="3ikh5c1uvgeva" />} data-id="element-13" data-mp="23ti67z10skhk" />
            <Route path="/bestall" element={<Checkout data-id="element-16" data-mp="3ii4su47vuwpm" />} data-id="element-15" data-mp="3ij61k21ff746" />
            <Route path="/admin" element={<Admin data-id="element-18" data-mp="3mk86mzi0yde2" />} data-id="element-17" data-mp="3ml14tc2x3ukl" />
          </Routes>
        </main>
        <Footer data-id="element-19" data-mp="3rc9hqi3ghy2i" />
      </div>
      </BrowserRouter>
    </CartProvider>
    </ContentProvider>;
}